import Vue from 'vue'

export default class AdminApiUsageActivity {
  constructor() {
    this.start_time = ''
    this.end_time = ''
    this.interval = '1h'
    this.overlay = null
    this.top_limit = 10
    this.totalSeries = { values: [], overall: { sum: 0 } }
    this.overlaySeries = null
    this.organizations = []
    this.endpoints = []
    this.tokens = []
    this.completeThrough = null
    this.complete = true
    this.missingBuckets = []
    this.snapBounds = null
    this.organizationNames = {}
  }

  visibleSeries() {
    const total = {
      id: 'environment-total',
      kind: 'total',
      label: 'All PAT requests',
      values: this.totalSeries.values || [],
    }
    if (!this.overlaySeries) {
      return [total]
    }
    const overlayLabel = this.overlaySeries.kind === 'org'
      ? `Organization: ${this.organizationNames[this.overlaySeries.key] || this.overlaySeries.key}`
      : `Endpoint: ${this.overlaySeries.key}`
    return [
      total,
      {
        id: `overlay:${this.overlaySeries.kind}:${this.overlaySeries.key}`,
        kind: 'overlay',
        label: overlayLabel,
        values: this.overlaySeries.values || [],
      },
    ]
  }

  hasChartData() {
    return this.visibleSeries().some((series) => (series.values || []).length)
  }

  chartData() {
    return this.visibleSeries().map((series, index) => ({
      device_index: -1,
      metric_index: index,
      metric_name: series.id,
      label: series.label,
      data: (series.values || []).map((point) => ({
        x: point.timestamp || null,
        y: point.value == null ? null : Number(point.value),
      })),
    }))
  }

  requestBody() {
    const body = {
      start_time: this.start_time,
      end_time: this.end_time,
      interval: this.interval,
      top_limit: this.top_limit,
    }
    // The request validator allows an object here, so an unset overlay has to
    // be omitted rather than sent as null.
    if (this.overlay && this.overlay.kind && this.overlay.key) {
      body.overlay = this.overlay
    }
    return body
  }

  fetch() {
    return Vue.axios.post('/usage/admin/query', this.requestBody()).then((result) => {
      const data = result.data || {}
      this.totalSeries = data.total_series || { values: [], overall: { sum: 0 } }
      this.overlaySeries = data.overlay || null
      this.organizations = data.organizations || []
      this.endpoints = data.endpoints || []
      this.tokens = data.tokens || []
      this.completeThrough = data.complete_through || null
      this.complete = data.complete !== false
      this.missingBuckets = data.missing_buckets || []
      this.snapBounds = data.snap_bounds || null
      this.interval = data.interval || this.interval
      return this.visibleSeries()
    })
  }
}
